<template>
  <a target="_blank" :href="filePath" class="btn btn-default">
    <span class="fas fa-file"></span> {{ file.displayName }}
  </a>
</template>
<script>
  import { getFileTypes } from '@authoringPlatform/../api/folders';
  import { mapState } from 'vuex';

  const getFileTypeFolder = (fileName) => {
    let fileTypeFolder = '';

    if (/\.png|\.jpeg|\.jpg/.test(fileName)) fileTypeFolder = 'images';
    else if (/\.pdf/.test(fileName)) fileTypeFolder = 'pdfs';
    else fileTypeFolder = 'documents';

    return fileTypeFolder;
  };

  export default {
    name: 'MailFile',

    props: {
      file: {
        type: Object,
        required: true,
      },
    },

    async mounted() {
      try {
        // TODO: Move this somewhere else
        const fileTypes = await getFileTypes();
        this.fileTypes = fileTypes;
      } catch (e) {
        console.log(e);
      }
    },

    computed: {
      ...mapState('editMode', ['assetsPath']),
      filePath() {
        const { FK_fileTypeKey, fileName } = this.file;
        if (FK_fileTypeKey === 2) return fileName;
        return `${this.assetsPath}/capsiminbox/${getFileTypeFolder(fileName)}/${fileName}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media print {
    a.btn:after {
      content: '' !important;
    }
  }
</style>
